export function getPathWithQuery(
  pathWithQuery: string,
  queryValues: Record<string, string>,
): string {
  const url = new URL(`http://www.fake.com${pathWithQuery}`)

  for (const [key, value] of Object.entries(queryValues)) {
    url.searchParams.set(key, value)
  }

  return `${url.pathname}${url.search}`
}
